import { forwardRef } from "react"
import { VariantProps } from 'class-variance-authority'
import { Check } from "lucide-react"
import { checkboxVariants } from "./styles"
import { twMerge } from "tailwind-merge"
import { ErrorMessage } from "@/common/components/ErrorMessage"
import { replacePeriodToUnderscore } from "@/common/utils/transformers";

export interface CheckboxProps extends React.HTMLAttributes<HTMLInputElement>, VariantProps<typeof checkboxVariants> {
  label: string,
  Icon?: JSX.Element,
  name?: string,
  value?: string
  labelClassName?: string
  labelContainerClassName?: string
  boxClassName?: string
  disabled?: boolean
  errorMessage?: string;
  checked?: boolean
  type?: "radio" | "checkbox"
  dataTestidPrefix?: string
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  Icon,
  name = '',
  id,
  labelClassName = '',
  labelContainerClassName = '',
  boxClassName = '',
  disabled,
  errorMessage,
  className,
  dataTestidPrefix = '',
  ...props
}, ref) => {
  return (
    <label
      className={twMerge("relative flex cursor-pointer items-start gap-3", disabled && 'cursor-default', className)}
      htmlFor={id}
      data-ripple-dark="true"
      onClick={(e) => e.stopPropagation()}
      data-testid={(dataTestidPrefix || name) ? (replacePeriodToUnderscore(dataTestidPrefix || name) + '_checkbox_box') : ''}
    >
      <input
        id={id}
        name={name}
        type='checkbox'
        ref={ref}
        className="before:content[''] peer hidden"
        data-testid={(dataTestidPrefix || name) ? (replacePeriodToUnderscore(dataTestidPrefix || name) + '_checkbox_input') : ''}
        disabled={disabled}
        {...props}
      />
      <div className={twMerge("flex justify-center items-center text-transparent peer-checked:text-white-800  pointer-events-none h-5 w-5 border rounded-md bg-gray-disabled border-gray-disabled peer-checked:border-success peer-checked:bg-success shrink-0", boxClassName)}>
        <Check size='14px' />
      </div>
      <div className={twMerge("flex flex-col items-start", labelContainerClassName)}>
        <div className="flex items-center gap-2">
          <p className={twMerge(`text-sm`, labelClassName)}>{label}</p>

          {Icon}
        </div>

        {errorMessage && <ErrorMessage name={name} message={errorMessage} />}
      </div>
    </label>
  )
})

export default Checkbox
